import { useDispatch, useSelector } from "react-redux";
import { useForm } from 'react-hook-form';
import { CLIENTALL, SERVICEALL, WORKALL, WORK, USERALL, TASKALL } from "../../services/actions";
import { useNavigate, useLocation } from "react-router-dom";
import React from "react";
import { Button, Container, Box, Grid, Tab, Tabs, Pagination, Card, Typography, Avatar, Stack, Divider, Chip } from "@mui/material";
import MyCard from "../extra/Card";
import { BsFilePlusFill } from "react-icons/bs";
import Form from './Form';
import ActionBar from "../extra/ActionBar";
import SearchBar from "../extra/SearchBar";
import { isBase64Image, seedData } from "../../libs/Libs";
import XTable from "../extra/XTableAnother";
import MoreInfo from "../extra/MoreInfo";
import { BsCopy } from "react-icons/bs";
import NoData from "../extra/NoData";
import WorkTaskDiscussionsModal from "./WorkTaskDiscussionsModal";

let colorMap = {
  pending: { label: "Pending", color: "#64748b" },
  todo: { label: "To Do", color: "#64748b" },
  inprogress: { label: "In Progress", color: "#3d3db0ff" },
  in_progress: { label: "In Progress", color: "#3d3db0ff" },
  completed: { label: "Completed", color: "#2e7d32" },
  approved: { label: "Approved", color: "#179a17ff" },
  Approved: { label: "Approved", color: "#179a17ff" },
  reject: { label: "Reject", color: "#d52a2aff", ct: 1 },
  rejected: { label: "Rejected", color: "#d52a2aff", ct: 1 },
  undereview: { label: "Under Review", color: "#57f6deff", ct: 1 },
  review: { label: "Under Review", color: "#57f6deff", ct: 1 },
  overdue: { label: "Overdue", color: "#dc2626", ct: 1 },
}
export default function View() {
  let dispatch = useDispatch()
  const [open, setOpen] = React.useState(false)
  const [defV, setDefV] = React.useState({})
  const [view, setView] = React.useState(1);
  const [discussionsModalOpen, setDiscussionsModalOpen] = React.useState(false);
  const [selectedWorkForDiscussion, setSelectedWorkForDiscussion] = React.useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  let workState = useSelector((state) => state?.workState)
  let workallState = useSelector((state) => state?.workallState)
  let clientallState = useSelector((state) => state?.clientallState)
  let serviceallState = useSelector((state) => state?.serviceallState)
  let userallState = useSelector((state) => state?.userallState);
  let taskallState = useSelector((state) => state?.taskallState);
  let user = useSelector((state) => state?.loginState?.auth)
  const [page, setPage] = React.useState(0); // current page  
  const pageSize = 20; // number of items per page (your API seems to default to 20)
  const [statusFilter, setStatusFilter] = React.useState(location.state?.status || "");
  const [idFilter, setIdFilter] = React.useState(location.state?.filter?.id || null);
  const [managerFilter, setManagerFilter] = React.useState("");

  const fetchWorks = (pageNum = 0, statusVal = statusFilter, filterId = idFilter, managerVal = managerFilter) => {
    let url = pageNum === 0 ? `work/${pageNum}/` : `work/?page=${pageNum}`;
    let filterParams = {};
    if (filterId) {
      filterParams.id = filterId;
    }
    if (managerVal) {
      filterParams.work_manager = managerVal;
    }
    if (Object.keys(filterParams).length > 0) {
      url = `work/0/?filter_by=${JSON.stringify(filterParams)}`;
    }
    if (statusVal) {
      url += (url.includes('?') ? '&' : '?') + `status=${statusVal}`;
    }
    dispatch({ type: `${WORKALL}_GET`, payload: url });
  }
  const fetchClients = (page = 0) => {
    const url = page === 0 ? `client/${page}/` : `client/?page=${page}`;// pass page number    
    dispatch({ type: `${CLIENTALL}_GET`, payload: url });
  }
  const fetchServices = (page = 0) => {
    const url = page === 0 ? `service/${page}/` : `service/?page=${page}`;// pass page number    
    dispatch({ type: `${SERVICEALL}_GET`, payload: url });
  }
  const fetchUsers = (page = 0) => {
    const url = page === 0 ? `public/user/0/?filter_by={"is_active":true}` : `user/?page=${page}`; // pass page number
    dispatch({ type: `${USERALL}_GET`, payload: url });
  };

  const fetchTasks = (id = 0) => {
    const url = `service/task/${page}/?filter_by={"service_id":${id}}`; // pass page number
    dispatch({ type: `${TASKALL}_GET`, payload: url });
  };

  React.useEffect(() => {
    if (location.state?.status !== undefined) {
      setStatusFilter(location.state.status || "");
      setIdFilter(null);
    } else if (location.state?.filter?.id !== undefined) {
      setIdFilter(location.state.filter.id);
      setStatusFilter("");
    }
  }, [location.state]);

  React.useEffect(() => {
    try {
      fetchUsers(0);
      if (user.permissions.includes("work.add_work")) {
        fetchClients(0);
        fetchServices(0);
      }
    } catch (err) { }
  }, []);

  React.useEffect(() => {
    fetchWorks(page, statusFilter, idFilter, managerFilter);
  }, [page, statusFilter, idFilter, managerFilter]);

  React.useEffect(() => {

    if (workState?.success) {
      setOpen(!workState?.success)
      fetchWorks(0);
    }

  }, [workState?.data])

  // Handle filter search
  const handleSearch = (key, value) => {
    if (!value) {
      fetchWorks(page, statusFilter, idFilter, managerFilter);
      return;
    }
    const query = `work/0/?filter_by={"${key}__icontains":"${value}"}`;
    dispatch({ type: `${WORKALL}_GET`, payload: query });
  };
  const tableHeadings = ["ID", "Work Name", "Client Name", "Service Name", "Manager", "Financial Year", "Status"];
  const tableRows = workallState?.data?.results?.map((work) => {
    const isOverdue = work.is_overdue && !['completed', 'approved'].includes(work.status);
    return {
      id: work.id,
      work_name: work.work_name,
      client_name: work.client_name,
      service_name: work.service_name,
      work_manager: work.work_manager_name || "—",
      financial_year: work.financial_year,
      status: isOverdue ? 'overdue' : (work.status || 'pending'),
    };
  });

  const handleStatusFilter = (e) => {
    const st = e.target.value;
    setStatusFilter(st);
    setIdFilter(null);
    setPage(0);
  };

  const managerUsers = React.useMemo(() => {
    return (userallState?.data?.results || []).filter((u) => {
      if (!u) return false;
      if (u.is_superuser) return true;
      const role = (u.main_role || "").toLowerCase();
      const groups = (Array.isArray(u.group) ? u.group : Array.isArray(u.groups) ? u.groups : []).map(
        (g) => (typeof g === "string" ? g : g?.name || "").toLowerCase()
      );
      return (
        role.includes("manager") ||
        role.includes("admin") ||
        groups.some((g) => g.includes("manager") || g.includes("admin"))
      );
    });
  }, [userallState]);

  const reviewerUsers = React.useMemo(() => {
    return (userallState?.data?.results || []).filter((u) => {
      if (!u) return false;
      const role = (u.main_role || "").toLowerCase();
      const groups = (Array.isArray(u.group) ? u.group : Array.isArray(u.groups) ? u.groups : []).map(
        (g) => (typeof g === "string" ? g : g?.name || "").toLowerCase()
      );
      const perms = Array.isArray(u.permissions) ? u.permissions : [];
      return (
        role.includes("review") ||
        role.includes("approv") ||
        groups.some((g) => g.includes("review") || g.includes("approv")) ||
        perms.some((p) => p.includes("can_approve_task") || p.includes("review"))
      );
    });
  }, [userallState]);

  const handleDelete = (id) => {
    dispatch({ type: `${WORK}_DELETE`, payload: id });
  };

  return (
    <>

      {open ? <>
        <Form
          users={managerUsers}
          reviewers={reviewerUsers}
          clients={clientallState?.data?.results || []}
          services={serviceallState?.data?.results || []}
          tasks={taskallState?.data?.results || []}
          defaultValues={defV}
          onChange={(c, v) => {
            if ("service" == c) {
              fetchTasks(v)
            }
          }}

          onSubmit={(data) => {
            if (!isBase64Image(data.image)) {
              delete data["image"]
            }

            let action = data.id ? `${WORK}_PATCH` : `${WORK}_POST`
            dispatch({ type: action, payload: data })
          }}
          back={() => { setOpen(false) }}
        /></>
        : <Container maxWidth="false" className="py-3">
          <ActionBar
            showGrid={[2, 5]}
            onBtnClick={(type, col) => {
              if (type === "grid") {
                setView(1);
              }
              if (type === "tabular") {
                setView(2);
              }
            }}
            hasPermission={true}
            label="Works" setOpen={(s) => {
              setDefV({});
              setOpen(true);
            }}
            btnLabel={user.permissions.includes("work.add_work") ? "ADD WORK" : null} />
          <Box 
            sx={{ 
              display: 'flex', 
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: { xs: 'stretch', md: 'center' }, 
              gap: 1.5, 
              flexWrap: { xs: 'wrap', md: 'nowrap' }, 
              mb: 3,
              width: '100%'
            }}
          >
            <Box sx={{ width: { xs: '100%', md: '175px' }, flexShrink: 0 }}>
              <select 
                onChange={handleStatusFilter} 
                value={statusFilter} 
                style={{ 
                  height: '40px',
                  width: '100%',
                  padding: '0 12px', 
                  borderRadius: '8px', 
                  border: '1px solid #cbd5e1', 
                  backgroundColor: '#ffffff',
                  fontSize: '13px',
                  fontWeight: 500,
                  color: '#1e293b',
                  outline: 'none',
                  cursor: 'pointer'
                }}
              >
                <option value="">Filter by Status (All)</option>
                <option value="pending">Pending</option>
                <option value="todo">To Do</option>
                <option value="in_progress">In Progress</option>
                <option value="completed">Completed</option>
                <option value="approved">Approved</option>
                <option value="undereview">Under Review</option>
                <option value="overdue">Overdue</option>
                <option value="rejected">Rejected</option>
              </select>
            </Box>

            <Box sx={{ width: { xs: '100%', md: '195px' }, flexShrink: 0 }}>
              <select 
                onChange={(e) => {
                  setManagerFilter(e.target.value);
                  setIdFilter(null);
                  setPage(0);
                }} 
                value={managerFilter} 
                style={{ 
                  height: '40px',
                  width: '100%',
                  padding: '0 12px', 
                  borderRadius: '8px', 
                  border: '1px solid #cbd5e1', 
                  backgroundColor: '#ffffff',
                  fontSize: '13px',
                  fontWeight: 500,
                  color: '#1e293b',
                  outline: 'none',
                  cursor: 'pointer'
                }}
              >
                <option value="">Filter by Manager (All)</option>
                {managerUsers.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.first_name || m.username || `Manager #${m.id}`}
                  </option>
                ))}
              </select>
            </Box>

            <Box sx={{ flexGrow: 1, width: { xs: '100%', md: 'auto' } }}>
              <SearchBar 
                bylist={[
                  { key: "work_name", label: "Work Name" },
                  { key: "client__business_name", label: "Client Name" },
                  { key: "service__service_name", label: "Service Name" },
                  { key: "work_manager__first_name", label: "Work Manager" }
                ]} 
                handleSearch={handleSearch} 
                sx={{ mb: 0 }}
              />
            </Box>
          </Box>
          {view === 1 && (
            <>
              {workallState?.loading ? (
                <NoData loading={true} loadingTitle="Loading Works..." loadingMessage="Please wait while we fetch work records." />
              ) : !workallState?.data?.results || workallState?.data?.results?.length === 0 ? (
                <NoData title="No Works Found" message="There are currently no work records to display. Try adjusting your status or search filters." />
              ) : (
                <>
                  <Grid container spacing={1}>
                    {workallState?.data?.results?.map((data, idx) => {
                      const isOverdue = data.is_overdue && !['completed', 'approved'].includes(data.status);
                      const displayStatus = isOverdue ? 'overdue' : (data.status || 'pending');
                      return <Grid alignItems="stretch" size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3, xxl: 2 }}>

                        <MyCard
                          head={<Typography sx={{ color: colorMap?.[displayStatus]?.color || '#64748b', fontSize: 13, fontWeight: 700 }}>{displayStatus.replace('_', ' ').toUpperCase()}</Typography>}
                          title={data.work_name}
                          subtitle={data.client_creation_date}
                          onAction={(action) => {
                            if ("more-info" === action) {
                              navigate("/more-info/", {
                                state: {
                                  data: data,
                                  title: "Service Task",
                                  prevNav: { url: '/works/', state: { state: { data } } }
                                }
                              })
                            } else if ("edit" === action) {
                              setDefV(data)
                              setOpen(true)
                            } else if ("delete" === action) {
                              handleDelete(data?.id)
                            }

                          }}
                        >
                          <Stack spacing={1.5} sx={{ mt: 0.5 }}>
                            <Box sx={{ p: 1.5, bgcolor: '#f8fafc', borderRadius: 2, border: '1px solid #f1f5f9' }}>
                              <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1.5}>
                                <Box>
                                  <Typography fontSize={11} color="textSecondary" textTransform="uppercase" letterSpacing={0.5} fontWeight={600}>Client</Typography>
                                  <Typography fontSize={13} fontWeight={700} color="#1e293b" lineHeight={1.2}>{data.client_name}</Typography>
                                </Box>
                                <Box textAlign="right">
                                  <Typography fontSize={11} color="textSecondary" textTransform="uppercase" letterSpacing={0.5} fontWeight={600}>FY</Typography>
                                  <Typography fontSize={12} fontWeight={700} color="#3b82f6">{data?.financial_year}</Typography>
                                </Box>
                              </Box>

                              <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1.5}>
                                <Box>
                                  <Typography fontSize={11} color="textSecondary" textTransform="uppercase" letterSpacing={0.5} fontWeight={600}>Service</Typography>
                                  <Typography fontSize={13} fontWeight={600} color="#1e293b" lineHeight={1.2}>{data.service_name}</Typography>
                                </Box>
                                <Box textAlign="right">
                                  <Typography fontSize={11} color="textSecondary" textTransform="uppercase" letterSpacing={0.5} fontWeight={600}>Manager</Typography>
                                  <Typography fontSize={12} fontWeight={700} color="#059669" lineHeight={1.2}>
                                    {data.work_manager_name || "—"}
                                  </Typography>
                                </Box>
                              </Box>

                              <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Box>
                                  <Typography fontSize={11} color="textSecondary" textTransform="uppercase" letterSpacing={0.5} fontWeight={600}>Tasks</Typography>
                                  <Chip
                                    size="small"
                                    label={data?.tasks?.length == 0 ? "0" : data?.tasks?.length}
                                    color={data?.tasks?.length == 0 ? "default" : "primary"}
                                    sx={{ fontWeight: 700, height: 20, fontSize: 11, borderRadius: 1 }}
                                  />
                                </Box>
                                {data?.assigned_employees?.length > 0 && (
                                  <Box textAlign="right">
                                    <Typography fontSize={11} color="textSecondary" textTransform="uppercase" letterSpacing={0.5} fontWeight={600}>Assigned</Typography>
                                    <Typography fontSize={12} fontWeight={600} color="#6366f1" lineHeight={1.2}>
                                      {data.assigned_employees.join(', ')}
                                    </Typography>
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          </Stack>

                          <Box mt={2}>
                            <Typography fontSize={11} color="textSecondary" sx={{ mb: 1, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>Documents</Typography>
                            <Stack direction="row" spacing={0.8} flexWrap="wrap" useFlexGap>
                              {["Reference", "Client Docs", "Working File", "Other"].map((d) => (
                                <Chip
                                  key={d}
                                  label={d}
                                  size="small"
                                  onClick={() => {
                                    let param = `object_id=0&client=${data.repo_uuid}&category=${encodeURIComponent(d)}&work=${encodeURIComponent(data.work_name || "")}&service=${encodeURIComponent(data.service_name || "")}&client_name=${encodeURIComponent(data.client_name || "")}&back=/works/`
                                    // if (data.files !== undefined) {
                                    //   param = `files=${JSON.stringify(data.files)}&object_id=0&client=${data.repo_uuid}&category=${d}&work=${data.work_name}&service=${data.service_name}&client_name=${data.client_name}&back=/works/`
                                    // }
                                    navigate(`/repository/documents/0?${param}`)
                                  }}
                                  sx={{
                                    fontSize: 11,
                                    fontWeight: 600,
                                    height: 24,
                                    cursor: 'pointer',
                                    background: '#eff6ff',
                                    color: '#2563eb',
                                    border: '1px solid #bfdbfe',
                                    borderRadius: '6px',
                                    transition: 'all 0.2s',
                                    '&:hover': { background: '#dbeafe', borderColor: '#93c5fd', transform: 'translateY(-1px)' }
                                  }}
                                />
                              ))}
                            </Stack>
                          </Box>

                          <Box mt="auto" pt={2}>
                            {/* Dedicated Top Chat / Discussion Button */}
                            <Button
                              variant="outlined"
                              size="small"
                              fullWidth
                              sx={{
                                textTransform: 'none',
                                borderRadius: '8px',
                                fontWeight: 600,
                                fontSize: 12,
                                height: 32,
                                mb: 1,
                                borderColor: '#bfdbfe',
                                color: '#2563eb',
                                bgcolor: '#eff6ff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 0.8,
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                  bgcolor: '#dbeafe',
                                  borderColor: '#93c5fd',
                                  transform: 'translateY(-1px)'
                                }
                              }}
                              onClick={() => {
                                setSelectedWorkForDiscussion(data);
                                setDiscussionsModalOpen(true);
                              }}
                            >
                              💬 Discussion &amp; Chat
                            </Button>

                            {/* Bottom 3 Action Buttons */}
                            <Stack direction="row" spacing={0.8} justifyContent="space-between">
                              {user.permissions.includes("work.view_worktask") &&
                                <Button
                                  variant="outlined"
                                  size="small"
                                  sx={{
                                    textTransform: 'none',
                                    borderRadius: '8px',
                                    fontWeight: 600,
                                    fontSize: 12,
                                    height: 32,
                                    flex: 1,
                                    borderColor: '#cbd5e1',
                                    color: '#334155',
                                    bgcolor: '#ffffff',
                                    '&:hover': { bgcolor: '#f8fafc', borderColor: '#94a3b8' }
                                  }}
                                  onClick={() => navigate(`/tasks/?work=${data.id}&work_name=${data.work_name}&back=/works/`)}
                                >
                                  Tasks
                                </Button>
                              }
                              {(user.permissions.includes("work.can_assign_task") || user.permissions.includes("work.add_workassigned") || user.main_role === "Work Manager" || user.main_role === "Work Admin") &&
                                <Button
                                  variant="outlined"
                                  size="small"
                                  sx={{
                                    textTransform: 'none',
                                    borderRadius: '8px',
                                    fontWeight: 600,
                                    fontSize: 12,
                                    height: 32,
                                    flex: 1,
                                    borderColor: '#cbd5e1',
                                    color: '#334155',
                                    bgcolor: '#ffffff',
                                    '&:hover': { bgcolor: '#f8fafc', borderColor: '#94a3b8' }
                                  }}
                                  onClick={() => navigate('/work-assign/', { state: { data: data, prevNav: "/works/" } })}
                                >
                                  Assign
                                </Button>
                              }
                              <Button
                                variant="contained"
                                size="small"
                                sx={{
                                  textTransform: 'none',
                                  borderRadius: '8px',
                                  fontWeight: 600,
                                  fontSize: 12,
                                  height: 32,
                                  flex: 1.1,
                                  backgroundColor: "#8b5cf6",
                                  boxShadow: "0 2px 4px rgba(139, 92, 246, 0.25)",
                                  '&:hover': {
                                    backgroundColor: "#7c3aed",
                                    boxShadow: "0 4px 6px rgba(139, 92, 246, 0.35)",
                                  }
                                }}
                                onClick={() => navigate(`/work-axis/routemap/${data.id}`)}
                              >
                                RouteMap
                              </Button>
                            </Stack>
                          </Box>
                        </MyCard>
                      </Grid>
                    })}
                  </Grid>
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Pagination
                      count={Math.ceil(workallState?.data?.count / pageSize)}
                      page={page}
                      onChange={(e, value) => setPage(value)}
                      color="primary"
                    />
                  </Box>
                </>
              )}
            </>
          )}
          {view === 2 && (
            <XTable
              head={tableHeadings}
              rows={tableRows}
              onEdit={(row) => {
                // Find the original project data from the full results
                const originalData = workallState?.data?.results.find(
                  (project) => project.id === row.id
                );

                // Set the form's default values and open the form
                if (originalData) {
                  setDefV(originalData);
                  setOpen(true);
                }
              }}
              onDelete={handleDelete}
            />
          )}
          {view === 4 && <MoreInfo
            data={{
              ...defV,
              active: defV.active ? "Yes" : "No",
              verify: defV.verify ? "Yes" : "No",
            }}

            skip={['country', 'description', 'error_email', 'no_users', 'owner']}
            group={['', 'work_name', 'created_at',]}
            onClose={() => { setView(1) }} />}

          <WorkTaskDiscussionsModal
            open={discussionsModalOpen}
            onClose={() => {
              setDiscussionsModalOpen(false);
              setSelectedWorkForDiscussion(null);
            }}
            work={selectedWorkForDiscussion}
          />
        </Container>}

    </>
  )
}